<div class="skeletor-partners">
  <div class="skeletor-partners-header">
    <p-skeleton [width]="'18rem'" [height]="'1.4rem'" />
    <p-skeleton [width]="'28rem'" [height]="'1rem'" />
  </div>

  <div class="skeletor-card">
    <div class="skeletor-card-body">
      <p-skeleton [width]="'12rem'" [height]="'1rem'" />
      <p-skeleton [width]="'100%'" [height]="'2.2rem'" />
    </div>
  </div>

  <div class="skeletor-table">
    <div class="skeletor-table-header">
      <p-skeleton [width]="'6rem'" [height]="'0.9rem'" />
      <p-skeleton [width]="'10rem'" [height]="'0.9rem'" />
      <p-skeleton [width]="'8rem'" [height]="'0.9rem'" />
      <p-skeleton [width]="'10rem'" [height]="'0.9rem'" />
      <p-skeleton [width]="'8rem'" [height]="'0.9rem'" />
      <p-skeleton [width]="'10rem'" [height]="'0.9rem'" />
      <p-skeleton [width]="'6rem'" [height]="'0.9rem'" />
      <p-skeleton [width]="'6rem'" [height]="'0.9rem'" />
      <p-skeleton [width]="'6rem'" [height]="'0.9rem'" />
      <p-skeleton [width]="'6rem'" [height]="'0.9rem'" />
      <p-skeleton [width]="'6rem'" [height]="'0.9rem'" />
    </div>
    <div class="skeletor-table-body">
      <div class="skeletor-table-row" *ngFor="let i of rows">
        <p-skeleton [width]="'6rem'" [height]="'0.9rem'" />
        <p-skeleton [width]="'12rem'" [height]="'1rem'" />
        <p-skeleton [width]="'8rem'" [height]="'0.9rem'" />
        <p-skeleton [width]="'10rem'" [height]="'0.9rem'" />
        <p-skeleton [width]="'8rem'" [height]="'0.9rem'" />
        <p-skeleton [width]="'10rem'" [height]="'0.9rem'" />
        <p-skeleton [width]="'6rem'" [height]="'0.9rem'" />
        <p-skeleton [width]="'6rem'" [height]="'0.9rem'" />
        <p-skeleton [width]="'6rem'" [height]="'0.9rem'" />
        <p-skeleton [width]="'6rem'" [height]="'0.9rem'" />
        <div class="skeletor-actions">
          <p-skeleton shape="circle" [width]="'1.5rem'" [height]="'1.5rem'" />
          <p-skeleton shape="circle" [width]="'1.5rem'" [height]="'1.5rem'" />
        </div>
      </div>
    </div>
  </div>
</div>

